import IntlTelInput from "intl-tel-input/reactWithUtils";
import CustomAdvanceDropdown from "../components/CustomAdvanceDropdown";
import { convertToTitleCase, CountrySelectoptions2, getCountrySelectedOpt, LanguageSelectoptions2 } from "../common/Helper";
import Select2 from 'react-select2-wrapper';
import 'react-select2-wrapper/css/select2.css';
import DatePicker from 'react-date-picker';
import "flag-icons/css/flag-icons.min.css";
import React from "react";

const CheckoutInput = React.memo(({
    type,
    field,
    idx,
    handleCountrySelectChange,
    handleChangeMainContact,
    onChangeCustomDropdown,
    onChangeDate,
    handleLanguageSelectChange,
    handleNumberChange,
    handleValidityChange,
    passenger = null,
    form
}) => {

    // console.log(field);



    switch (type) {
        case 'phoneNumber':
            return (
                <div className="box-box">
                    <label className="commonLabelSecond">{convertToTitleCase(field?.field)}
                        {
                            field?.required == true &&
                            <font className="req-sym">*</font>
                        }
                    </label>
                    <IntlTelInput
                        // ref={inputRef}
                        initialValue={field?.value}
                        onChangeNumber={(e) => handleNumberChange(passenger?.id, e, field.field_name, form)}
                        onChangeValidity={(e) => handleValidityChange(e,passenger?.id,field.field_name,form)}
                        // formatOnDisplay={false}
                        showFlags={true}
                        initOptions={{
                            initialCountry: 'auto',
                            separateDialCode: true,
                            // geoIpLookup: geoIpLookup,
                        }}

                    />
                    {field?.error && <span className="cus-err">{field?.error}</span>}
                </div>
            )
        case 'gender':
            let label = "Gender"

            return (
                <div className="box-box" key={idx}>
                    <CustomAdvanceDropdown
                        label={label}
                        options={["Male", "Female"]}
                        selectedState={field?.value ? (field.value == 'm' ? 'Male' : 'Female') : "Select Gender"}
                        setSelectedState={(e) => onChangeCustomDropdown(passenger?.id, e, field.field_name, form)}
                        required={field?.required}
                    />
                    {field?.error && <span className="cus-err">{field?.error}</span>}
                </div>
            );

        case 'nationality':
            return (
                <div className="box-box" key={idx}>
                    <label className="commonLabelSecond">{convertToTitleCase(field?.field)}
                        {
                            field?.required == true &&
                            <font className="req-sym">*</font>
                        }
                    </label>
                    <Select2
                        data={CountrySelectoptions2}
                        value={field.value}
                        options={{
                            placeholder: 'Select nationality',
                            // allowClear: true,
                            escapeMarkup: (markup) => markup, // Enable rendering HTML
                            templateResult: (data) => data.text, // Render dropdown options with icons
                            templateSelection: (data) => data.text, // Render selected item with icon
                        }}
                        onChange={(e) => handleCountrySelectChange(passenger?.id, e, field.field_name, form)}
                    />
                    {field?.error && <span className="cus-err">{field?.error}</span>}
                </div>
            );

        case 'country':
            return (
                <div className="box-box" key={idx}>
                    <label className="commonLabelSecond">{convertToTitleCase(field?.field)}
                        {
                            field?.required == true &&
                            <font className="req-sym">*</font>
                        }
                    </label>
                    <Select2
                        data={CountrySelectoptions2}
                        value={field.value}
                        options={{
                            placeholder: 'Select country',
                            // allowClear: true,
                            escapeMarkup: (markup) => markup, // Enable rendering HTML
                            templateResult: (data) => data.text, // Render dropdown options with icons
                            templateSelection: (data) => data.text, // Render selected item with icon
                        }}
                        onChange={(e) => handleCountrySelectChange(passenger?.id, e, field.field_name, form)}
                    />
                    {field?.error && <span className="cus-err">{field?.error}</span>}
                </div>
            );

        case 'email':
            return (
                <div className="box-box" key={idx}>
                    <label className="commonLabelSecond">{convertToTitleCase(field?.field)}
                        {
                            field?.required == true &&
                            <font className="req-sym">*</font>
                        }
                    </label>
                    <input
                        className="commonInputSecond"
                        type="email"
                        name={field.field_name}
                        value={field.value}
                        onChange={(e) => handleChangeMainContact(passenger?.id, field.field_name, e)}

                    />
                    {field?.error && <span className="cus-err">{field?.error}</span>}
                </div>
            );

        case 'passportExpiry':
            return (
                <div className="box-box" key={idx}>
                    <label className="commonLabelSecond">{convertToTitleCase(field?.field)}
                        {
                            field?.required == true &&
                            <font className="req-sym">*</font>
                        }
                    </label>
                    <DatePicker
                        //   onChange={(e)=>setDate(e)}
                        value={field.value}
                        onChange={(e) => onChangeDate(passenger?.id, e, field.field_name, form)}
                        dayPlaceholder={''}
                        yearPlaceholder={''}
                        monthPlaceholder={''}
                        format="MM/dd/yyyy"
                        clearIcon={null}
                        className={[]}

                    />
                    {field?.error && <span className="cus-err">{field?.error}</span>}
                </div>
            );

        case 'dateOfBirth':
            return (
                <div className="box-box" key={idx}>
                    <label className="commonLabelSecond">{convertToTitleCase(field?.field)}
                        {
                            field?.required == true &&
                            <font className="req-sym">*</font>
                        }
                    </label>
                    <DatePicker
                        onChange={(e) => onChangeDate(passenger?.id, e, field.field_name, form)}
                        value={field.value}
                        dayPlaceholder={''}
                        yearPlaceholder={''}
                        monthPlaceholder={''}
                        clearIcon={null}
                        format="MM/dd/yyyy"
                        className={[]}
                        maxDate={new Date()}

                    />
                    {field?.error && <span className="cus-err">{field?.error}</span>}
                </div>
            );

        case 'language':
            return (
                <div className="box-box" key={idx}>
                    <label className="commonLabelSecond">{convertToTitleCase(field?.field)}
                        {
                            field?.required == true &&
                            <font className="req-sym">*</font>
                        }
                    </label>
                    <Select2
                        data={LanguageSelectoptions2}
                        value={field.value}
                        options={{
                            placeholder: 'Select a Language',
                            // allowClear: true,
                            escapeMarkup: (markup) => markup, // Enable rendering HTML
                            templateResult: (data) => data.text, // Render dropdown options with icons
                            templateSelection: (data) => data.text, // Render selected item with icon
                        }}
                        onChange={(e) => handleLanguageSelectChange(passenger?.id, e, field.field_name, form)}
                    />
                    {field?.error && <span className="cus-err">{field?.error}</span>}
                </div>
            );

        case 'title':
            return (
                <div className="box-box" key={idx}>
                    <CustomAdvanceDropdown
                        label={"Title"}
                        options={["Mr", "Mrs", "Miss"]}
                        selectedState={field?.value ? field?.value : "Select Title"}
                        setSelectedState={(e) => onChangeCustomDropdown(passenger?.id, e, field.field_name, form)}
                        required={field?.required}
                    />
                    {field?.error && <span className="cus-err">{field?.error}</span>}
                </div>

            );

        default:
            return (
                <div className="box-box" key={idx}>
                    <label className="commonLabelSecond">{convertToTitleCase(field?.field)}
                        {
                            field?.required == true &&
                            <font className="req-sym">*</font>
                        }
                    </label>
                    <input
                        className="commonInputSecond"
                        type="text"
                        name={field.field_name}
                        value={field.value}
                        id={form + "_" + (passenger?.id ? passenger?.id : idx) + "_" + field.field_name}
                        onChange={(e) => handleChangeMainContact(passenger?.id, field.field_name, e)}

                    />
                    {field?.error && <span className="cus-err">{field?.error}</span>}

                </div>
            );
    }


}, (prevProps, nextProps) => {
    // Only re-render if field.value or field_name changes
    return prevProps.field.value === nextProps.field.value &&
        prevProps.field.field_name === nextProps.field.field_name &&
        prevProps.field.error === nextProps.field.error;
})
export default CheckoutInput;